import { isDeviationPixelArt, isFileLargerThanSize } from '../../../_helpers';
import MediaService from '../../../../utils/DeviationMediaService';
import { useDeviationViewContext } from '../../../../Context';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useSelector } from 'react-redux';
import { getIsDuperbrowseActive } from '../../../../Duperbrowse/redux/selectors';
import { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import useDeviationDrag from '../../../../Dnd/useDeviationDrag';
import ddt from '@wix/da-ddt';
export function useImageFile(_a) {
    var width = _a.width, height = _a.height, deviation = _a.deviation, isZoomed = _a.isZoomed;
    var lcp2 = useFlag('lcp2'); // use thumb not fullview
    // const { isLoggedIn } = useContext(SessionContext);
    var isMobile = useContext(MobileContext);
    var isDuperbrowse = useSelector(function (state) { return getIsDuperbrowseActive(state); });
    var isFullscreen = useDeviationViewContext().isFullscreen;
    var isPixel = isDeviationPixelArt(deviation);
    var zoomedFile = MediaService.getLargestFullview(deviation);
    var isBiggerThanStage = !!zoomedFile && // must have a fullview
        !MediaService.isGif(deviation) && // must not be a gif as selecting sized one will give you static jpg sometimes
        isFileLargerThanSize(zoomedFile, width, height); // must be larger than the artstage
    var _b = useDeviationDrag({
        deviation: deviation,
    }), dragPreview = _b.dragPreview, drag = _b.drag;
    var file;
    // Mobile handling optimises anon traffic for better LCP on slow devices
    if (isMobile && lcp2) {
        // Duperbrowse & loggedin uses the fullview always
        if (isDuperbrowse /* || isLoggedIn */) {
            file = isBiggerThanStage
                ? MediaService.getFullviewForSize(deviation, isZoomed ? 0 : width, isZoomed ? 0 : height)
                : zoomedFile;
        }
        // Anon Canonical uses mobile/small screen selection logic to get the smallest
        // thumb for the artstage but still respect gifs etc this will use fullview if
        // the stage is huge for tablets etc
        if (lcp2 && !isDuperbrowse /* && !isLoggedIn */) {
            file = isBiggerThanStage
                ? MediaService.getSmallestThumbForArtStage(deviation, width || 360, height || 360)
                : zoomedFile;
        }
    }
    else {
        // Desktop handling
        file = isBiggerThanStage
            ? MediaService.getFullviewForSize(deviation, isZoomed ? 0 : width, isZoomed ? 0 : height)
            : zoomedFile;
    }
    ddt.log('deviation', 'Using fullview file', file);
    return {
        file: file,
        zoomedFile: zoomedFile,
        isPixel: isPixel,
        isFullscreen: isFullscreen,
        drag: isMobile ? undefined : drag,
        dragPreview: isMobile ? null : dragPreview,
        canZoom: isBiggerThanStage,
    };
}
//# sourceMappingURL=useImageFile.js.map